export default "__VITE_ASSET__4055e4fe__"